<template>
  <div>
    <!-- Overbought -->
    <helpers-section-sub-header class="mt-8 mb-2">
      Average Directional Index (ADX)
    </helpers-section-sub-header>
    <p>ADX assesses the strength of a trend in stock prices.</p>

    <v-data-table :headers="ta_headers" :items="criteria.adx_rules" class="mt-6 mb-8">
      <template #top>
        <v-dialog v-model="taDialog" scrollable max-width="450px">
          <template #activator="{ props }">
            <v-btn color="primary" dark class="mb-4" v-bind="props"> New ADX Rule </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ taTitle }}</span>
            </v-card-title>

            <v-card-text style="height: 350px">
              <p>ADX assesses the strength of a trend in stock prices.</p>
              <v-container>
                <v-row density="compact">
                  <v-col cols="12" sm="12">
                    <v-checkbox v-model="editedTa.enabled" density="compact" label="Rule Enabled" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="editedTa.long_short"
                      :items="long_short"
                      label="Signal Type"
                      hint="Long or Short Signal"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="editedTa.term"
                      :items="['5', '15']"
                      label="ADX Number of Days"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="editedTa.threshold"
                      density="compact"
                      hide-details
                      variant="outlined"
                      label="ADX Threshold"
                    />
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-select
                      v-model="editedTa.above_below"
                      :items="['above', 'below']"
                      label="ADX above or below threshold"
                      hint="ADX above or below threshold"
                      density="compact"
                      hide-details
                      variant="outlined"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1" />
              <v-btn color="blue-darken-1" text @click="closeTa"> Cancel </v-btn>
              <v-btn color="blue-darken-1" text @click="saveTa"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editTa(item)"> edit </v-icon>
        <v-icon small @click="deleteTa(item)"> delete </v-icon>
      </template>

      <template #item.enabled="{ item }">
        <v-switch v-model="item.enabled" color="primary" />
      </template>
      <template #no-data> No KAMA signals configured </template>
    </v-data-table>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  data() {
    return {
      taDialog: false,
      long_short: ['long', 'short'],
      ta_headers: [
        {
          title: 'Enabled',
          align: 'left',
          sortable: true,
          key: 'enabled'
        },
        {
          title: 'Rule Type',
          align: 'left',
          sortable: true,
          key: 'long_short'
        },
        {
          title: 'ADX',
          align: 'left',
          sortable: true,
          key: 'term'
        },
        {
          title: 'Above/Below',
          align: 'left',
          sortable: true,
          key: 'above_below'
        },
        {
          title: 'Threshold',
          align: 'left',
          sortable: true,
          key: 'threshold'
        },
        { title: 'Actions', key: 'action', sortable: false }
      ],
      editedTa: {
        enabled: true,
        above_below: 'above',
        term: '5',
        consecutive_days: 5,
        threshold: 20,
        long_short: 'long'
      },
      defaultTa: {
        enabled: true,
        above_below: 'above',
        term: '5',
        consecutive_days: 5,
        threshold: 20,
        long_short: 'long'
      },
      editedIndex: -1
    }
  },

  computed: {
    taTitle() {
      return this.editedIndex === -1 ? 'New Rule' : 'Edit Rule'
    },
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {
    taDialog(val) {
      val || this.closeTa()
    }
  },

  created() {},

  methods: {
    editTa(item) {
      this.editedIndex = this.criteria.adx_rules.indexOf(item)
      this.editedTa = Object.assign({}, item)
      this.taDialog = true
    },

    deleteTa(item) {
      const index = this.criteria.adx_rules.indexOf(item)
      confirm('Are you sure you want to delete this rule?') &&
        this.criteria.adx_rules.splice(index, 1)
    },

    closeTa() {
      this.taDialog = false
      setTimeout(() => {
        this.editedTa = Object.assign({}, this.defaultTa)
        this.editedIndex = -1
      }, 300)
    },

    saveTa() {
      if (this.editedIndex > -1) {
        Object.assign(this.criteria.adx_rules[this.editedIndex], this.editedTa)
      } else {
        if (!this.criteria.adx_rules) {
          this.criteria.adx_rules = []
        }
        this.criteria.adx_rules.push(this.editedTa)
      }
      this.closeTa()
    }
  }
}
</script>
